export const checkIsValidCardPan = (cardPan: string): boolean => /\b\d{4}\s?\d{4}\s?\d{4}\s?\d{4}\b/.test(cardPan);
